module.exports = __webpack_public_path__ + "img/41_51.f2567619.png";